(function () {
    'use strict';

    angular
        .module('laekkerAI.tablet')
        .controller('ForceCheckinQuestionController', [
            'KitchenJobService',
            function (jobService) {

            var $ctrl = this;

            $ctrl.$onInit = function () {
                if($ctrl.resolve !== undefined) {
                    angular.extend($ctrl, $ctrl.resolve);
                }
            };

            $ctrl.doIt = function () {
                jobService.forceCheckIn($ctrl.job, $ctrl.quantity, function () {
                    $ctrl.close();
                });
            };

        }]);
})();